import React from 'react';
import { Layout } from '../../../queries/ats/layout/types';
import { classes } from '../../../utils/commonUtils';
import { AtsItemOverwrites } from '../ats-asset/atsAsset.interfaces';
import { AtsItem } from '../AtsItem';
import styles from './AtsGenre.module.scss';

interface AtsGenresProps {
  item: Layout.SectionItem;
  pattern: Layout.Pattern;
  overwrites?: AtsItemOverwrites;
}

export default function AtsGenre({ item, pattern, overwrites, ...rest }: AtsGenresProps) {
  return (
    <AtsItem item={item} pattern={pattern} className={styles.link} overwrites={overwrites} {...rest}>
      {item.name || item.title?.titleName || item.slug}
    </AtsItem>
  );
}

export function AtsGenreSkeleton({ pattern }: Pick<AtsGenresProps, 'pattern'>) {
  return <div className={classes(styles.skeleton, styles.link)} />;
}

AtsGenre.Skeleton = AtsGenreSkeleton;
